export default __webpack_public_path__ + "static/media/dynamic-allround-chem.ce1923fe.jpg";